import { LocalizedLink } from '@/components/LocalizedLink';
import { Button } from '@/components/ui/button';
import { ArrowRight, Phone } from 'lucide-react';
import { useT } from '@/lib/i18n';

interface LandingPageCTAProps {
  heading: string;
  description: string;
}

export function LandingPageCTA({ heading, description }: LandingPageCTAProps) {
  const t = useT();
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary/10 via-background to-primary/5 py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl rounded-3xl border border-primary/20 bg-card/50 p-10 text-center backdrop-blur-sm md:p-14">
          <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            {heading}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
            {description}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="group">
              <LocalizedLink to="/consulting#contact">
                {t('Kostenloses Erstgespräch', 'Free initial consultation')}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </LocalizedLink>
            </Button>
            <Button asChild variant="outline" size="lg">
              <a href="tel:+4961501849730">
                <Phone className="mr-2 h-4 w-4" />
                06150 184973-0
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}